<template>
  <div class="container">
    <div class="w-[80%]">
      <div class="font-semibold text-[30px] text-font-1 leading-[42px]">
        {{ info.title }} {{ currentTheme }}
      </div>
      <div class="text-[16px] text-font-60 leading-[22px] mt-[12px]">
        {{ info.description }}
      </div>
      <a-carousel class="carousel" autoplay :after-change="onChange" :dots="true">
        <div
          v-for="item in infos"
          :key="!isChinese() ? (isDark ? item.en_dark_img : item.en_img) || item.img : item.img"
          class="rounded-[16px] overflow-hidden"
        >
          <img
            class="w-full"
            loading="lazy"
            :src="!isChinese() ? (isDark ? item.en_dark_img : item.en_img) || item.img : item.img"
          />
        </div>
      </a-carousel>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { isChinese } from '~/utils/area';
const { $t } = useNuxtApp();
const currentTheme = useTheme();
const isDark = computed(() => currentTheme?.value === 'dark');

const infos = [
  {
    title: $t('tuan-dui-xie-zuo-chuang-zuo'),
    description: $t(
      'zhi-chi-tuan-dui-nei-duo-ren-xie-zuo-chuang-zuo-ti-gong-gao-xiao-de-qi-ye-tuan-dui-shi-pin-chuang-zuo-ping-tai',
    ),
    img: getFeUrl('/youyan-platform/png/share_space.png?x-oss-process=image/format,webp'),
    en_img: getFeUrl('/youyan-platform/png/team-space-0715.png?x-oss-process=image/format,webp'),
    en_dark_img: getFeUrl(
      '/youyan-platform/png/team-space-en-dark.jpg?x-oss-process=image/format,webp',
    ),
  },
  {
    title: $t('zai-xian-zi-yuan-gong-xiang'),
    description: $t(
      'zhi-chi-tuan-dui-nei-zi-yuan-ji-wen-jian-tong-bu-gong-xiang-liu-zhuan-ti-gong-tuan-dui-kong-jian-cun-chu-xie-zuo-zi-yuan',
    ),
    img: getFeUrl('/youyan-platform/png/share_space2.png?x-oss-process=image/format,webp'),
    en_img: getFeUrl('/youyan-platform/png/share_with_me.png?x-oss-process=image/format,webp'),
    en_dark_img: getFeUrl(
      '/youyan-platform/png/share-with-me-en-dark.jpg?x-oss-process=image/format,webp',
    ),
  },
];

const current = ref(1);

const onChange = (index: number) => {
  current.value = index;
};

const info = computed(() => infos[current.value]);
</script>
<style lang="scss" scoped>
.container {
  @apply flex flex-row-reverse items-center;
  // background: linear-gradient(
  //   to bottom right,
  //   #e1fff9 0%,
  //   #f6fffd 50%,
  //   #d8d5ff 100%
  // );
}

.carousel {
  @apply mt-[50px];
  box-shadow: 0px 3px 25px 0px rgba(81, 80, 96, 0.2);
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

:global(.carousel.ant-carousel .slick-dots-bottom) {
  bottom: -12px;
}
</style>
